<template>
    <div class="dropdown-select">
        <div class="dropdown-select-wrap" @click="onShowSelect">
            <slot name="prefix"></slot>
            {{ value }}
            <span class="dropdown-select-icon"></span>
        </div>
        <ul v-show="isSelect" class="dropdown-select-options">
            <li @click="onSelectItem(item)" v-for="(item, index) in options" :key="index" class="dropdown-select-option">
                {{ item.startTime }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'WeekSelect',
        model: {
            prop: 'value',
            event: 'update:value'
        },
        props: {
            value: {
                type: String,
                default: '',
            },
            options: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                isSelect: false,
            }
        },
        watch: {
            options(val) {
                if (val.length > 0) {
                    this.selectedVal = val[0].startTime
                }
            },
        },
        methods: {
            onShowSelect() {
                this.isSelect = !this.isSelect
            },
            //选择年份
            onSelectItem(item) {
                this.selectedVal = item.startTime
                this.isSelect = false
                this.$emit('update:value', item.startTime)
                if (this.value !== item.startTime) {
                    this.$emit('change', item)
                }
            },
        },
    }
</script>

<style scoped>

.dropdown-select {
    position: relative;
}
.dropdown-select-wrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 12px 22px;
    background: #fff3d3;
    border-radius: 30px;
    box-shadow: 0px 1px 0px 1px rgba(153,37,6,0.41), 0px -2px 4px 2px #ebc595 inset; 
    font-size: 24px;
    font-weight: bold;
    color: #6F6C68;
    cursor: pointer;
}
.dropdown-select-icon {
    width: 0;
    height: 0;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid #E4AE6E;
    border-radius: 16px;
}
.dropdown-select-options {
    position: absolute;
    top: 62px;
    left: 0;
    width: 100%;
    height: 300px;
    overflow-y: scroll;
    margin: 0;
    padding: 0;
    background-color: #fff3d3;
    border: 1px solid #ccc;
    border-radius: 24px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    z-index: 10;
    list-style: none;
}
.dropdown-select-options::-webkit-scrollbar {
    display: none;
}
.dropdown-select-option {
    padding: 12px 16px;
    font-size: 24px;
    font-weight: bold;
    color: #6F6C68;
    cursor: pointer;
}
</style>